// Resolve a file's MIME type, falling back to its extension when the browser
// reports an empty `file.type`. iOS Safari commonly returns "" for HEIC photos
// (and occasionally other files); sending "application/octet-stream" then trips
// the server's claimed-type allowlist and the upload 415s. Mapping the common
// allowed extensions to their canonical MIME lets phone uploads succeed.
//
// Keep this list a subset of the backend ALLOWED_MIME_TYPES set
// (documents.py) — anything here still gets libmagic-sniffed server-side.
const EXT_MIME: Record<string, string> = {
  pdf: "application/pdf",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  heic: "image/heic",
  heif: "image/heif",
  webp: "image/webp",
  txt: "text/plain",
  // Chrome reports .md as an empty type, so without this it falls to
  // application/octet-stream and the upload allowlist rejects it. AI notetakers
  // export markdown more often than anything else, and the workspace reads it
  // fine as plain text — the extension was the only thing standing in the way.
  md: "text/plain",
  markdown: "text/plain",
  csv: "text/csv",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};

export function resolveMime(file: File): string {
  if (file.type) return file.type;
  const ext = file.name.split(".").pop()?.toLowerCase() || "";
  return EXT_MIME[ext] || "application/octet-stream";
}
